export default "__VITE_ASSET__DSLChiFa__"